import { type BlokProps, StoryblokComponent, StoryblokComponentList } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import type { PageStoryblok } from "@/generated/sb/sb-types";

export const PageBlok = ({ blok, preview }: BlokProps<PageStoryblok>) => {
	return (
		<BlokWrap editable={blok} as="main" className="bg-background-bg-sand-1">
			{blok.header &&
				blok.header.length > 0 &&
				blok.header.map((blok, i) => (
					<StoryblokComponent key={i} blok={blok} preview={preview} isHeader />
				))}
			{blok.body && blok.body.length > 0 && (
				<StoryblokComponentList bloks={blok.body} preview={preview} />
			)}
		</BlokWrap>
	);
};
